import React, { useContext } from 'react';
import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';
import ProductListingInsideModal from '../../ProductListingModalOptions/AU/Presentation/ProductListingInsideModal';
import ProductListingCustomModalForm from '../Presentation/ProductCustomModalForm';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { UserOrderContext } from 'context/context';
import { isEmptyObject } from 'common/utilities/utils';
import {
  checkIfAnyModifierChanged,
  resetModifierNewProps,
  updateModifierFromNewProps,
} from 'organisms/MenuPDPPage/AU/Utilities/MenuPDPUtils';
import { filteredModGroups } from 'organisms/ProductListingModalOptions/AU/Container/ProductListingModalOptionsComponent';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';

export const getModgrpBySelectedModifier = (currentItemObject, showCustomizationModId, showCustomizationModGrpId) => {
  let selectedModifier = {};
  if (currentItemObject) {
    let selectedModgroup = currentItemObject.modgrps?.find(modG => modG.id === showCustomizationModGrpId);
    if (isEmptyObject(selectedModgroup)) {
      selectedModifier = selectedModgroup.modifiers?.find(modF => modF.id === showCustomizationModId);
    }
  }
  return selectedModifier;
};

const ProductListingCustomComponent = props => {
  const { isModal = true, showPriceContent = true, data = {}, isStoreClosed = false, localized, catalog } = props;
  const { PDP_PAYLOAD_DATA, SHOWTOASTALERT, RESET_SHOW_PDP_CUSTOM_MODAL, HASH_SYMBOL, SET_PDP_BUTTON_DISABLED } =
    MENU_PDP_PAGE_CONSTANTS;
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { pdpPayloadData, sopacPDPCustomization } = userOrderState;
  const {
    showCustomizationModId = '',
    showCustomizationModGrpId = '',
    showCustomizationModGrpName = '',
  } = sopacPDPCustomization;
  const currentItemObject = useSelector(({ menuReducer: { currentItemDetails } }) => currentItemDetails);
  const currentItemDetailsModified = isEmptyObject(data)
    ? filteredModGroups(data)
    : getModgrpBySelectedModifier(currentItemObject, showCustomizationModId, showCustomizationModGrpId);
  const onDismissedSelection = pdpPayloadDataInfo => {
    userOrderStateDispatch({ type: SHOWTOASTALERT, value: false });
    let data = resetModifierNewProps(
      pdpPayloadDataInfo,
      `${showCustomizationModGrpId}${HASH_SYMBOL}${showCustomizationModId}`,
    );
    userOrderStateDispatch({ type: PDP_PAYLOAD_DATA, value: data });
    userOrderStateDispatch({ type: SET_PDP_BUTTON_DISABLED, value: {} });
    userOrderStateDispatch({ type: RESET_SHOW_PDP_CUSTOM_MODAL }); //close modal
  };
  /**
   *
   * @param {*} element - method to handle close of the modal
   */
  const handleClose = event => {
    event.stopPropagation();
    event.preventDefault();
    let flag = checkIfAnyModifierChanged(
      pdpPayloadData,
      `${showCustomizationModGrpId}${HASH_SYMBOL}${showCustomizationModId}`,
    );
    if (flag) {
      userOrderStateDispatch({ type: SHOWTOASTALERT, value: true }); //show dismiss selection toast
    } else {
      onDismissedSelection(pdpPayloadData);
    }
  };

  const confirmHandler = event => {
    event.stopPropagation();
    event.preventDefault();
    let data = updateModifierFromNewProps(
      pdpPayloadData,
      `${showCustomizationModGrpId}${HASH_SYMBOL}${showCustomizationModId}`,
    );
    data = resetModifierNewProps(data, `${showCustomizationModGrpId}${HASH_SYMBOL}${showCustomizationModId}`);
    onDismissedSelection(data);
  };

  const productListingCustomModalForm = (
    <ProductListingCustomModalForm
      data={currentItemDetailsModified}
      handleClose={handleClose}
      confirmHandler={confirmHandler}
      showPriceContent={showPriceContent}
      data-testid='product-listing-modal-enabled'
      isModal={isModal}
      isStoreClosed={isStoreClosed}
      localized={localized}
      onDismissedSelection={onDismissedSelection}
      catalog={catalog}
    />
  );
  const renderElement = (
    <ProductListingInsideModal
      handleClose={handleClose}
      ProductListingModalForm={productListingCustomModalForm}
      headerText={`${translateWithI18Next(
        TRANSLATE_MAPPING_KEY.CUSTOMISE_YOUR,
      )?.toLowerCase()} ${showCustomizationModGrpName?.value?.toLowerCase()}`?.replace(/\b(\w)/g, char => char?.toUpperCase())}
      data-testid='product-listing-inside-modal'
      closeDataTestId='handle-close'
    />
  );

  const pdpProductCustomizations = <div className='pdp-custm-sopac'>{productListingCustomModalForm}</div>;
  return !isModal
    ? pdpProductCustomizations
    : ReactDOM.createPortal(renderElement, document.getElementById('modal-popups'));
};

export default ProductListingCustomComponent;
